import React, { useState, useCallback } from "react";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory, useLocation } from "react-router-dom";
import getSymbolFromCurrency from 'currency-symbol-map'
import { connect } from "react-redux";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { loginToApp } from "../../redux-services/actions/actions";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../../components/CustomButtons/Button.js";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import { primaryColor, primaryIconColor } from "../../style.scss";
import { ReactComponent as ConfirmTransactionIcon } from '../../assets/img/payshap_journey.svg'
import { v4 as uuidv4 } from 'uuid';
import { DCustomerManagementApi, QPaymentsApi } from "eclipse-react-sdk/services";
import { SpinnerComponent } from "react-element-spinner";
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import { AuthQueryParamWithTemplateId } from "../../default-route.js";
import { ToBinary } from "../../utils.js";


const useStyles = makeStyles(themeStyle);

export function ConfirmPayShapAmount(props) {
  const walletDetailData = useLocation()?.state?.walletDetailData;
  const scannedQRData = useLocation()?.state?.scannedQRData;
  const paymentDetails = useLocation()?.state?.paymentDetails;
  const cardDetailData = useLocation()?.state?.cardDetailData;
  const paymentProcess = useLocation()?.state?.paymentProcess;
  const fromScreen = useLocation()?.state?.fromScreen;
  const shapID =useLocation()?.state?.shapID;

  const history = useHistory();
  const classes = useStyles();
  const [isLoading, setLoading] = useState(false);
  const [alertData, setAlert] = useState(null);

  const showAlert = (alertDisplay, alertType, message) => {
    setAlert({ isAlertDisplay: alertDisplay, alertType: alertType, alertMessage: message })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const backToQRPay = () => {
    history.push({
      pathname: '/pages/pay-payshap-amount',
      state: { scannedQRData: scannedQRData, fromScreen: fromScreen,shapID:shapID }
    });
  };

   const getRecipientBank =(shapID) => {
    const pattern = /@(.+)/;
    const match = shapID.match(pattern);
    return match[1]
  }

  const backToDashboard = useCallback(() => {
    const appData = {
      ...props?.appData,
      isRefresh: true
    }
    props.confirmPayAmountHandler(appData);
    history.push({
      pathname: '/pages/dashboard',
    });
  }, [history, props])

  const redirectToErrorScreen = (fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen: fromScreen }
    });
  }

  const doQRWalletTransfer = () => {
    setLoading(true);
    const selectedWallet = props?.appData?.wallets?.filter(wallet => wallet?.walletId === paymentDetails.fromWalletCard)[0];
    const qrWalletTransferAPI = new DCustomerManagementApi();
    const createQRTransferWalletBody = {
      externalUniqueId: uuidv4(),
      type: "PAYSHAP",
      currency: 'ZAR',
      paymentData: scannedQRData?.code,
      walletId: selectedWallet?.walletId,
      landingUrl: `${window.location.origin}${process.env.PUBLIC_URL}/pages/success-card-payment${AuthQueryParamWithTemplateId() ? AuthQueryParamWithTemplateId() : ''}`,
    }
    qrWalletTransferAPI.tenantsTenantIdCustomersCustomerIdPaymentsPost(props?.appData?.auth?.tenantId, props?.appData?.customer?.customerId, createQRTransferWalletBody).then((qrWalletTransferAPIResponse) => {
      if (qrWalletTransferAPIResponse.data && qrWalletTransferAPIResponse.data?.paymentId && qrWalletTransferAPIResponse.data?.paymentId > 0) {
        updateQRPaymentAmount(qrWalletTransferAPIResponse.data);
      } else {
        setLoading(false);
        showAlert(true, 'ERROR', `Something went wrong. Please try again!`);
      }
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/dashboard', '/pages/error');
      }
    });
  }

  const updateQRPaymentAmount = (paymentData) => {
    const cardPaymentsAPI = new QPaymentsApi();
    const cardPaymentRequestBody = {
      amount:+paymentDetails?.amount,
      walletId:paymentData?.walletId,
      }
    
    cardPaymentsAPI.tenantsTenantIdPaymentsPaymentIdPut(props?.appData?.auth?.tenantId, paymentData?.paymentId, cardPaymentRequestBody).then((cardPaymentsAPIResponse) => {
      if (cardPaymentsAPIResponse?.data && cardPaymentsAPIResponse?.data?.paymentId) {
        const qrPaymentData = {
          paymentDetails:paymentDetails,
          paymentId: cardPaymentsAPIResponse.data?.paymentId,
          status: cardPaymentsAPIResponse.data?.status,
          scannedQRData,
          paymentProcess,
          cardDetailData,
          fromScreen,
          shapID,
          recipientBank:getRecipientBank(shapID),
          fromWalletCard:paymentDetails?.fromWalletCard,
          httpStatus:cardPaymentsAPIResponse?.status
        }
        if (cardPaymentsAPIResponse.data?.completionUrl) {
          window.localStorage.setItem('appstate', btoa(ToBinary(JSON.stringify({ ...props?.appData, qrPaymentData,walletDetailData }))));
          window.location.replace(cardPaymentsAPIResponse.data?.completionUrl);
        } else {
          const appData = {
            ...props?.appData,
            isRefresh: true,
            qrPaymentData,
            walletDetailData,
            scannedQRData
          }
          props.confirmPayAmountHandler(appData);
           history.push({
            pathname: '/pages/success-card-payment'
          });
        }
      } else {
        setLoading(false);
        showAlert(true, 'ERROR', `Something went wrong. Please try again!`);
      }
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) 
      {
         if(error.response.data[0].code==='DAE001'){
          showAlert(true,'ERROR',"Enter a valid ShapID")
         }
         else if(error.response.data[0].code==='PAY002'){
          showAlert(true,'ERROR',"The Payshap ID does not exist.")
         }
         else{
          showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
         }
      } else {
        redirectToErrorScreen('/pages/dashboard', '/pages/error');
      }
    });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
      doQRWalletTransfer();
    }

  return (
    <div>
      <SpinnerComponent loading={isLoading} position="global" color={primaryColor} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ display: 'flex' }}>
              <ArrowBackIosIcon className={classes.linkColor} onClick={backToQRPay}></ArrowBackIosIcon>
              <span className={classes.title}>Pay with PayShap</span>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'center', marginTop: '20px' }}>
              <ConfirmTransactionIcon />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0'}><b>Please confirm that you want to pay</b></p>
              <h2 style={{ color: primaryIconColor, margin: '0' }} className={classes.textCenter}><b>{getSymbolFromCurrency(props?.appData?.defaultWallet?.currency)}{(+paymentDetails?.amount + (paymentDetails?.tipAmount ? +paymentDetails?.tipAmount : 0)).toFixed(2)}</b></h2>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0'}><b>{paymentDetails?.reference? "Reference: "+paymentDetails?.reference :null}</b></p>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0 m-t-0'}><b> ShapID: {shapID}</b></p>
              <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0 m-t-0'}><b>Recipient’s bank: {getRecipientBank(shapID)}</b></p>
              {paymentProcess === 'WALLETS' ?
                <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0 '}><b> from your wallet: {walletDetailData?.name} - {paymentDetails.fromWalletCard}</b></p>
                : <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-b-0 m-t-0'}><b> from your wallet: card-{cardDetailData?.alias + ' - **' + cardDetailData?.last4Digits}</b></p>}
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={6} style={{ marginTop: '40px' }}>
              <Button className={classes.buttonRadius} size="lg" block color="transparent" onClick={backToDashboard} >Cancel</Button>
            </GridItem>
            <GridItem xs={6} sm={6} md={6} style={{ marginTop: '40px' }}>
              <Button className={classes.buttonRadius} size="lg" block color="primary" type="button" onClick={handleSubmit}>Continue</Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
    </div>
  )
}


const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  confirmPayAmountHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPayShapAmount)